import { Behavior } from '../behavior';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorContext } from '../behavior-context';

@Injectable()
export class HttpGetRequest implements Behavior {
  constructor(public http: HttpClient) {}
  async execute(
    args: { [key: string]: any },
    context: BehaviorContext
  ): Promise<any> {
    const result = await this.http.get(args.url).toPromise();
    context.set(args.resultKey || 'httpGetResult', result);
  }
}
